export default __webpack_public_path__ + "media/react/gre/organisms/checkpoints/assets/assessment_incomplete_3-6d154ddc1cb308145200560c8d31b2e0.svg";